module.exports = __webpack_public_path__ + "img/user-avatar-7.097741d4.png";